function Error429Form() {
  return (
    <main className='flex min-h-screen bg-[#F9F9F9] md:block md:bg-white'>
      <div className='grid w-full place-items-center py-10 md:p-0'>
        <div className='w-full max-w-[480px] rounded bg-white p-10 md:max-w-full md:px-10 md:py-20 sm:px-5'>
          <div className='space-y-6 text-center'>
            <h1 className='text-lg text-primary-500'>429 Too Many Requests Error</h1>
            <p className='text-lg font-semibold text-[#222222]'>
              過剰アクセスでエラーが発生しました。
            </p>
            <p className='leading-relaxed text-[#222222]'>
              アクセスが集中しております。
              <br />
              しばらく経ってからアクセスをお願いします。
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Error429Form;
